namespace $.$$ {

	type $shm_tests_screenshot = {
		path: string
		description: string
	}

	export class $shm_tests_screenshots extends $.$shm_tests_screenshots {

		data() {
			return this.result() as $shm_tests_app_result | null
		}

		screenshots() {
			const data = this.data()
			if( !data ) return [] as $shm_tests_screenshot[]
			const visual_paths = new Set( this.visuals().flatMap( item => [
				item.comparison.actual,
				item.comparison.expected,
				item.comparison.diff,
			].filter( Boolean ) as string[] ) )

			const screenshots = data.steps.flatMap( ( step, index ) => (
				( step.artifacts ?? [] )
					.filter( path => /\.(?:png|jpe?g|webp)$/i.test( path ) && !visual_paths.has( path ) )
					.map( path => ({
						path,
						description: `Шаг ${ index + 1 }. ${ step.title }`,
					}) )
			) )
			const linked = new Set( screenshots.map( screenshot => screenshot.path ) )

			for( const artifact of data.artifacts ) {
				if( !artifact.mime.startsWith( 'image/' ) || linked.has( artifact.path ) ) continue
				screenshots.push({
					path: artifact.path,
					description: `Скриншот ${ artifact.path.split( /[\\/]/ ).at( -1 ) ?? artifact.path }`,
				})
			}

			return screenshots
		}

		visuals() {
			return ( this.data()?.steps ?? [] ).flatMap( ( step, step_index ) => (
				( step.visual ?? [] ).map( ( comparison, visual_index ) => ({
					id: `${ step_index }:${ visual_index }`,
					step: step.title,
					comparison,
				}) )
		) )
		}

		visual( id: string ) {
			return this.visuals().find( item => item.id === id )?.comparison ?? null
		}

		summary_text() {
			const visuals = this.visuals()
			const changed = visuals.filter( item => ![ 'unchanged', 'updated' ].includes( item.comparison.status ) ).length
			const regular = this.screenshots().length
			return [
				`Сравнений: ${ visuals.length }`,
				`С отличиями: ${ changed }`,
				`Обычных скриншотов: ${ regular }`,
			].join( ' · ' )
		}

		screenshot_rows() {
			const rows = [
				... this.visuals().map( visual => this.Visual( visual.id ) ),
				... this.screenshots().map( screenshot => this.Screenshot( screenshot.path ) ),
			]
			return rows.length ? [ this.Summary(), ... rows ] : [ this.Empty() ]
		}

		screenshot( path: string ) {
			return this.screenshots().find( screenshot => screenshot.path === path )
		}

		screenshot_description( path: string ) {
			return this.screenshot( path )?.description ?? ''
		}

		screenshot_uri( path: string ) {
			return new URL(
				path.replace( /\\/g, '/' ),
				new URL( this.manifest_uri(), this.$.$mol_dom_context.location.href ),
			).toString()
		}

	}

}
